import { Row, Col, Typography } from "antd";
const { Text } = Typography;

const QtyDiscountPreview = ({ buy, free }) => {
  return buy > 0 && free > 0 ? (
    <Row style={{ width: "100%" }}>
      <Text strong style={{ color: "var(--ion-color-primary)" }}>
        <Text strong style={{ fontSize: "1.25rem", color: "var(--ion-color-primary)" }}>
          Buy {buy} get {free} free
        </Text>
      </Text>
    </Row>
  ) : null;
};

export default QtyDiscountPreview;
